<template>
<div class="chapter">
<div class="inner_page">
<div class="image_wrap_small">
<p class="image"><a id="page_3"></a><a href="http://www.chroniclebooks.com/" target="_blank"><img alt="image" class="horizontal" src="images/title.jpg"/></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03title.vue?5fd72086